var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"minWidth"},[_c('v-app',[_c('Manu'),_c('Loading'),_c('router-view'),_c('Version')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }